import CreateCompany from './CreateCompanyConnector';
import appPaths from '../../constants/appPaths';

export const route = {
    component: CreateCompany,
    label: 'Create Company',
    to: appPaths.createCompany,
};

export default [route];
